import React from 'react';
import Halla from '@/assets/media/SVGComponents/Halla';
import background from '@/assets/background.jpg';

const Loader = ({ showParentDiv = true, textColor = 'text-white' }) => {
    const content = (
        <>
            <div className="relative w-full h-32 flex items-center justify-center">
                <div className="animate-progress">
                    <Halla width={100} height={100} />
                </div>
            </div>
            <p className={`mt-4 text-2xl ${textColor} font-bold`}>Chargement...</p>
        </>
    );

    return (
        <>
            {showParentDiv ? <div
                className="flex flex-col items-center justify-center h-screen"
                style={{
                    backgroundImage: `url(${background})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                {content}
            </div> : content }
        </>
    );
};

export default Loader; 